import React, { useState } from 'react';
import { avatarTone, initialsOf } from '../Avatar/Avatar';
import './Student360.css';

export { avatarTone, initialsOf };

/**
 * The student's picture, or initials on a soft tone when there is none (or it does not load): the
 * same 40px circle as every other avatar in the CRM (`.ui-avatar`, a tone hashed from the seed so a
 * student keeps their colour on every screen). The name always sits next to it, so the avatar itself
 * is hidden from screen readers. `online` adds the green presence dot; `size="lg"` is the page hero.
 */
function StudentAvatar({
  name, avatar, seed, size = 'md', online = false,
}) {
  const [failed, setFailed] = useState(false);
  const url = typeof avatar === 'string' && /^https?:\/\//i.test(avatar) && !failed ? avatar : null;
  return (
    <span
      className={`ui-avatar s360-avatar${size === 'lg' ? ' is-lg' : ''}`}
      data-tone={avatarTone(seed || name)}
      aria-hidden="true"
    >
      {url
        // The picture is an address the student chose: it is fetched without telling that host which
        // CRM page it was asked from.
        ? <img src={url} alt="" loading="lazy" referrerPolicy="no-referrer" onError={() => setFailed(true)} />
        : initialsOf(name)}
      {online && <span className="ui-presence" />}
    </span>
  );
}

export default StudentAvatar;
